var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"jumbotron center-it"},[_c('h1',{staticClass:"display-5"},[_vm._v("Chargement...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }